export default "__VITE_ASSET__gJBuL7LF__"